import React from 'react';
import type { ExperimentValue } from './context';
import { ExperimentSelect } from './experiment-select';
import { ExperimentsListGrid, ExperimentsListWrapper } from './styles';

type ExperimentsListProps = Pick<
  ExperimentValue<unknown>,
  'selectedVariants' | 'experiments' | 'selectVariant'
>;

const fromKebab = (s: string) => s.replace(/-/g, ' ');
const fromCamel = (s: string) => s.replace(/([a-z])([A-Z])/g, '$1 $2');
const unCase = (s: string) => fromCamel(fromKebab(s));

export const ExperimentsList: React.FC<ExperimentsListProps> = ({
  experiments,
  selectVariant,
  selectedVariants,
}) => {
  return (
    <ExperimentsListWrapper>
      {experiments?.map(experiment => (
        <ExperimentsListGrid key={experiment.id}>
          <h4>{unCase(experiment.id)}</h4>
          <ExperimentSelect
            experiment={experiment}
            selectedVariant={selectedVariants?.[experiment.id]?.selectedVariant}
            onClick={variant => {
              selectVariant?.(experiment, variant);
            }}
          />
        </ExperimentsListGrid>
      ))}

      {!experiments?.length ? (
        <div style={{ whiteSpace: 'nowrap' }}>
          There are no experiments on this page
        </div>
      ) : null}
    </ExperimentsListWrapper>
  );
};
